import { PayloadAction } from '@reduxjs/toolkit';

import { EditorState } from 'editor/src/store/editor/types';

const setCropModeElementUuidReducer = (state: EditorState, action: PayloadAction<number | undefined>) => {
  state.cropModeElementUuid = action.payload;
};

export default setCropModeElementUuidReducer;
